export default __webpack_public_path__ + "static/media/fitt_hero.18cb9a49.webm";